import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';


export const GetAllMissingTicketNumbers = gql`
  query MissingTicketNumberSequences($only_not_expected: Boolean!) {
    missingTicketNumberSequences: all_missing_ticket_number_sequences(only_not_expected: $only_not_expected) {
      edges {
        node {
          id
          previousNumber: previous_number
          nextNumber: next_number
          totalMissing: total_missing
        }
      }
    }
  }
`;

const mapDataToProps = withProps((props) => {
  const { data } = props;
  const missingTicketNumbers = querySelector(data, '$.missingTicketNumberSequences.edges[*].node', []);
  return {
    missingTicketNumbers,
  };
});


const withData = graphql(GetAllMissingTicketNumbers);


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);


export default enhance;
